import { connectionTypes } from "@/service/config"

export const createConnectionModule = {
    namespaced: true,
    state() {
        return {
            sourceConnection: {
                file: {},
                selectedTab: {},
                tabs: [],
                isTabsLoading: false,
                isTabsLoaded: false
            },
            targetConnection: {
                file: {},
                selectedTab: {},
                tabs: [],
                isTabsLoading: false,
                isTabsLoaded: false
            }
        }
    },
    getters: {
        isFileEmpty: (state) => (connectionType) => {
            if (connectionType === connectionTypes.SOURCE) {
                return JSON.stringify(state.sourceConnection.file) === '{}'
            }
            else if (connectionType === connectionTypes.TARGET) {
                return JSON.stringify(state.targetConnection.file) === '{}'
            }
        },
        isSelectedTabEmpty: (state) => (connectionType) => {
            if (connectionType === connectionTypes.SOURCE) {
                return JSON.stringify(state.sourceConnection.selectedTab) === '{}'
            }
            else if (connectionType === connectionTypes.TARGET) {
                return JSON.stringify(state.targetConnection.selectedTab) === '{}'
            }
        },
        isConnectionEmpty: (state, getters) => (connectionType) => {
            return getters.isFileEmpty(connectionType) && getters.isSelectedTabEmpty(connectionType)
        },
        getFile: (state) => (connectionType) => {
            if (connectionType === connectionTypes.SOURCE) {
                return state.sourceConnection.file
            }
            else if (connectionType === connectionTypes.TARGET) {
                return state.targetConnection.file
            }
        },
        getTabs: (state) => (connectionType) => {
            if (connectionType === connectionTypes.SOURCE) {
                return state.sourceConnection.tabs
            }
            else if (connectionType === connectionTypes.TARGET) {
                return state.targetConnection.tabs
            }
        },
        getSelectedTab: (state) => (connectionType) => {
            if (connectionType === connectionTypes.SOURCE) {
                return state.sourceConnection.selectedTab
            }
            else if (connectionType === connectionTypes.TARGET) {
                return state.targetConnection.selectedTab
            }
        },
        getIsTabsLoading: (state) => (connectionType) => {
            if (connectionType === connectionTypes.SOURCE) {
                return state.sourceConnection.isTabsLoading
            }
            else if (connectionType === connectionTypes.TARGET) {
                return state.targetConnection.isTabsLoading
            }
        },
        getIsTabsLoaded: (state) => (connectionType) => {
            if (connectionType === connectionTypes.SOURCE) {
                return state.sourceConnection.isTabsLoaded
            }
            else if (connectionType === connectionTypes.TARGET) {
                return state.targetConnection.isTabsLoaded
            }
        },
        getConnection: (state, getters) => (connectionType) => {
            return {
                file: getters.getFile(connectionType),
                tab: getters.getSelectedTab(connectionType),
            }
        }
    },
    mutations: {
        saveFileSourceConnection(state, file) {
            state.sourceConnection.file = file
        },
        saveTabSourceConnection(state, tab) {
            state.sourceConnection.selectedTab = tab
        },
        saveFileTargetConnection(state, file) {
            state.targetConnection.file = file
        },
        saveTabTargetConnection(state, tab) {
            state.targetConnection.selectedTab = tab
        },
        saveTabsSourceConnection(state, tabs) {
            state.sourceConnection.tabs = tabs
        },
        saveTabsTargetConnection(state, tabs) {
            state.targetConnection.tabs = tabs
        },
        updateIsTabsSourceLoading(state, value) {
            state.sourceConnection.isTabsLoading = value
        },
        updateIsTabsTargetLoading(state, value) {
            state.targetConnection.isTabsLoading = value
        },
        updateIsTabsSourceLoaded(state, value) {
            state.sourceConnection.isTabsLoaded = value
        },
        updateIsTabsTargetLoaded(state, value) {
            state.targetConnection.isTabsLoaded = value
        },
    },
    actions: {
        saveFileConnection(state, {file, connectionType}) {
            if (connectionType === connectionTypes.SOURCE) {
                state.commit('saveFileSourceConnection', file)
            }
            else if (connectionType === connectionTypes.TARGET) {
                state.commit('saveFileTargetConnection', file)
            }
        },
        updateTabConnection(state, {tab, connectionType}) {
            if (connectionType === connectionTypes.SOURCE) {
                state.commit('saveTabSourceConnection', tab)
            }
            else if (connectionType === connectionTypes.TARGET) {
                state.commit('saveTabTargetConnection', tab)
            }
        },
        saveTabsConnection(state, {tabs, connectionType}) {
            if (connectionType === connectionTypes.SOURCE) {
                state.commit('saveTabsSourceConnection', tabs)
                state.commit('saveTabSourceConnection', tabs[0])
            }
            else if (connectionType === connectionTypes.TARGET) {
                state.commit('saveTabsTargetConnection', tabs)
                state.commit('saveTabTargetConnection', tabs[0])
            }
        },
        updateIsTabsLoading(state, {value, connectionType}) {
            if (connectionType === connectionTypes.SOURCE) {
                state.commit('updateIsTabsSourceLoading', value)
            }
            else if (connectionType === connectionTypes.TARGET) {
                state.commit('updateIsTabsTargetLoading', value)
            }
        },
        updateIsTabsLoaded(state, {value, connectionType}) {
            if (connectionType === connectionTypes.SOURCE) {
                state.commit('updateIsTabsSourceLoaded', value)
            }
            else if (connectionType === connectionTypes.TARGET) {
                state.commit('updateIsTabsTargetLoaded', value)
            }
        },
        clearConnections(state){
            state.commit('saveFileSourceConnection', {})
            state.commit('saveTabsSourceConnection', [])
            state.commit('saveTabSourceConnection', {})

            state.commit('saveFileTargetConnection', {})
            state.commit('saveTabsTargetConnection', [])
            state.commit('saveTabTargetConnection', {})
        }
    }
}